<div>
  <div id="vtable" class="table-responsive-sm">
    <table class="table table-bordered table-sm">
      <thead class="thead-light">
        <tr>
          <th scope="col">Section</th>
          @if (compareColumn=='all' || compareColumn=='instructor') {
            <th scope="col">Instructors</th>
          }
          @if (compareColumn=='all') {
            <th scope="col">Terms</th>
          }
          @if (compareColumn=='all') {
            <th scope="col">Credits</th>
          }
          @if (compareColumn=='all' || compareColumn=='meeting') {
            <th scope="col">Meeting Info</th>
          }
          @if (compareColumn=='all' || compareColumn=='seats') {
            <th scope="col">Enrollments</th>
          }
          @if (bidding && (compareColumn=='all' || compareColumn=='seats')) {
            <th scope="col">Bidding Seats (FY/SY)</th>
          }
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (section of sections; track section) {
          <tr>
            <td data-title="Section">
              @if (catalog.favorites$ | async; as favorites) {
                <i
                  [ngClass]="favorites.includes(section.SectionId.toString()) ? 'fas fa-star orange' : 'far fa-star gray'"
                  (click)="toggleColor(section.SectionId, favorites)">
                </i>
              }&nbsp;{{section.SectionNumber}} {{section.ShowTitleInCatalog ? section.Title : ''}}</td>
              @if (compareColumn=='all' || compareColumn=='instructor') {
                <td data-title="Instructors">
                  @for (instructor of section.Instructors; track instructor) {
                    <span>
                      <a class="instructor-link" href="javascript:void(0)" (click)="openProfile(instructors[instructor.PersonId])">
                        {{instructors[instructor.PersonId].DisplayNameStudents}}
                        @if (section.Instructors.length > 1) {
                          @for (role of instructor.InteractionTypes; track role) {
                            <small class="badge badge-light ms-1">
                              @if (role.IsActive) {
                                {{role.Type}}
                              }
                            </small>
                          }
                        }
                      </a><br />
                    </span>
                  }
                  @if (section.Instructors.length === 0) {
                    <span>
                      <em>[None]</em>
                    </span>
                  }
                </td>
              }
              @if (compareColumn=='all') {
                <td data-title="Terms">{{section.Terms.join(', ')}} @if (section.UbpModLabel.length > 0) {
                  <span>({{section.UbpModLabel}})</span>
                }</td>
              }
              @if (compareColumn=='all') {
                <td data-title="Credits">{{section.CreditHourDefault}}</td>
              }
              @if (compareColumn=='all' || compareColumn=='meeting') {
                <td data-title="Meeting Info">@for (meeting of section.Meetings; track meeting) {
                  <span>{{meeting.DisplayNameStudents}}</span>
                  }<br /><span>{{section.NonStandardMeetingInfo}}</span></td>
                }
                @if (compareColumn=='all' || compareColumn=='seats') {
                  <td data-title="Enrollments">
                    <div title="{{section.TotalEnrolled}} out of {{section.TotalAllocated}} seats are enrolled.{{section.Reserved != null ? ' ' + section.Reserved + ' seats are reserved.' : ''}}{{section.TotalWaitlisted != null ? ' ' + section.TotalWaitlisted + ' seats are waitlisted.' : ''}}">
                      @if (section.SeatChoice) {
                        <strong>{{section.PrimaryLabel}} </strong>
                        }{{section.TotalEnrolled}}/{{section.TotalAllocated}}
                        @if (section.Reserved != null) {
                          <span> ({{section.Reserved}}r)</span>
                          }@if (section.TotalWaitlisted != null) {
                          <span> ({{section.TotalWaitlisted}}w)</span>
                        }
                      </div>
                      @if (section.SeatChoice) {
                        <div title="{{section.SecondaryEnrolled}} out of {{section.SecondaryAllocated}} seats are enrolled.{{section.SecondaryWaitlisted != null ? ' ' + section.SecondaryWaitlisted + ' seats are waitlisted.' : ''}}">
                          <strong>{{section.SecondaryLabel}}</strong> {{section.SecondaryEnrolled}}/{{section.SecondaryAllocated}}
                          @if (section.SecondaryWaitlisted != null) {
                            <span> ({{section.SecondaryWaitlisted}}w)</span>
                          }
                        </div>
                      }
                    </td>
                  }
                  @if (bidding && (compareColumn=='all' || compareColumn=='seats')) {
                    <td data-title="Bidding Seats">{{section.BiddingSeatsFY}} / {{section.BiddingSeatsSY}}</td>
                  }
                  <td data-title="Actions">
                      @if (section.HasSyllabus && auth.hasFeature('CatalogSyllabusLink')) {
                      <div class="d-flex">
                          <button class="btn btn-sm btn-primary me-1 mb-1" (click)="catalog.downloadSyllabus(section)">
                              <i class="fas fa-file-download"></i> Course Resources<span class="sr-only">Course Resources Download</span>
                              @if (section.isSyllabusDownloading) {
                              <i class="fas fa-circle-notch fa-spin"></i>
                              }
                          </button>
                      </div>
                      }
                      @if (auth.hasFeature('CatalogBioBookLink')) {
                        <app-people-download-buttons [sectionId]="section.SectionId"></app-people-download-buttons>
                      }
                    @if (registration) {
                      @if (hasActiveRound(rounds, section.RoundId, 'add') && section.AllowsAdd) {
                        <button class="btn-success btn-sm btn" (click)="checkSeat(section)" [disabled]="isAddRunning[section.SectionId]">
                          Add
                          @if (isAddRunning[section.SectionId]) {
                            <span class="loader loader-sm loader-light ml-1" role="status" aria-hidden="true"></span>
                          }
                          <span class="sr-only">Add</span>
                        </button>
                      }
                      @if (hasActiveRound(rounds, section.RoundId, 'drop') && section.AllowsDrop && !section.IsWaitlisted) {
                        <button class="btn-danger btn-sm btn"
                          (click)="drop(section,'Drop')"
                          [disabled]="enrollmentService.isDropRunning[section.SectionId]">
                          <span>Drop {{section.SeatLabel}}</span>
                          @if (enrollmentService.isDropRunning[section.SectionId]) {
                            <span class="loader loader-sm loader-light ml-1" role="status" aria-hidden="true"></span>
                          }
                          <span class="sr-only">Drop</span>
                        </button>
                      }
                    }
                    @if (bidding) {
                      @if (section.InActiveBidRound && section.PointsBid <=0) {
                        <button class="btn-success btn-sm btn" (click)="bid(section)" [disabled]="isBidRunning[section.SectionId]">
                          Bid
                          @if (isBidRunning[section.SectionId]) {
                            <span class="loader loader-sm loader-light ml-1" role="status" aria-hidden="true"></span>
                          }
                          <span class="sr-only">Bid</span>
                        </button>
                      }
                      @if (section.InActiveBidRound && section.PointsBid > 0) {
                        <span>
                          <button type="button" class="btn btn-link" (click)="catalog.tabToShow='bids'">
                            {{section.PointsBid}} points bid
                          </button>
                        </span>
                      }
                    }
                    @if (section.AllowsAbandon) {
                      @if (section.IsWaitlisted && !section.HasClassEnded) {
                        <button class="btn-danger btn-sm btn"
                          (click)="drop(section,'Abandon')"
                          [disabled]="enrollmentService.isDropRunning[section.SectionId]">
                          <span>Abandon {{section.SeatLabel}}</span>
                          @if (enrollmentService.isDropRunning[section.SectionId]) {
                            <span class="loader loader-sm loader-light ml-1" role="status" aria-hidden="true"></span>
                          }
                          <span class="sr-only">Abandon</span>
                        </button>
                      }
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
